import Form from "src/components/CustomForm";
import useForm from "src/hooks/use-form";
import { useAlertContext } from "src/hooks/use-alert";
import { getitemsbyAsset, getEmailsOperators } from "src/apis/item";
import TicketValidator from "src/validators/ticket-validator.ts";
import {
  CreateTicket,
} from "src/apis/tickets";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import {
  ticketImpacts,
} from "src/util/utility_enums";
import { getAllAssets } from "src/apis/complex";
import { setInputs } from "src/util/generateInputs";
import { styled } from "@mui/material";

const useStyles = styled((theme) => {
  return {
    backButton: {
      marginRight: theme.spacing(1),
    },
    root: {
      display: "inline",
      flexDirection: "column",
      alignassets: "center",
      width: "100%",
    },
    field: {
      width: "30%",
      marginBottom: theme.spacing(2),
    },
  };
});

const validator = new TicketValidator();
// For successful validation, isTouched has to be true and has error has to be false for each field
//

const assetsList = [];
const sensorsList = [];

// To create a form, Create this object with eack key as the field of the form to create
var properties = {
  ticketDescription: {
    value: "",
    type: "text",
    multiline: true,
    isTouched: true,
    hasError: false,
  },

  notes: { value: "", type: "text", isTouched: false, hasError: false },

  asset: {
    value: "",
    type: "select",
    isTouched: false,
    hasError: false,
    enum: assetsList,
  },

  item: {
    value: "",
    type: "select",
    isTouched: false,
    hasError: false,
    enum: [],
  },
  isOnerous: {
    value: false,
    type: "checkbox",
    checked: false,
    isTouched: true,
    hasError: false,
  },
  ticketImpact: {
    value: "",
    type: "select",
    isTouched: false,
    hasError: false,
    enum: ticketImpacts,
  },
  mntOperatorEmail: {
    value: "",
    type: "select",
    isTouched: false,
    hasError: false,
    enum: [],
  },
  fee: {
    feeAmountProposal: {
      value: "",
      type: "number",
      parentName: "fee",
      isTouched: false,
      hasError: false,
    },
  },
};

export default function Ticket({ props }) {
  //props contain data regarding asset to from parent component
  const navigate = useNavigate();
  const alert = useAlertContext();
  const [assets, SetAssets] = useState([]);
  const [items, SetItems] = useState([]);
  const [emails, SetEmails] = useState([]);
  const [visible, setVisible] = useState(false);

  //console.log(props.ticketData);
  const classes = useStyles();
  const { inputs, errorMessages, isValid, hasError, submitValidationHandler } = useForm(validator, properties);

  const { fee } = inputs;

  const feeInputs = setInputs(classes, fee, errorMessages.fee);


  useEffect(() => {




  properties.asset.conditionSelect = true;
  properties.asset.conditionSelectChangeHandler = conditionSelectChangeHandler;

  properties.isOnerous.conditionCheckbox = true;
  properties.isOnerous.conditionCheckboxChangeHandler =
    conditionCheckboxChangeHandler;


    const fetchData = async () => {
      try {
        var assets = await getAllAssets();
        assets = assets.map((asset) => {
          return { id: asset.id, name: asset.name };
        });
        SetAssets(assets);

  properties.asset.enum = assets;
        // Do something with the assets (e.g., update state)
      } catch (error) {
        // Handle error if needed
        console.error(error);
      }
    };

    fetchData();
  }, []);


  const conditionSelectChangeHandler = async (props, handler) => {
    handler(props);
    switch (true) {
      case props.target.value !== "":
        var items = await getitemsbyAsset(props.target.value);
        items = items.map((i) => {
          return { id: i.id, name: i.serialNumber };
        });
        SetItems(items);
        await getEmailsOperators(props.target.value).then((res) => {
          if(res){
            const operators = res.map((o) => {
              return { id: o.id, value: o.email, name: o.name + " " + o.surname };
            });
            
            properties.item.enum = items;
            properties.mntOperatorEmail.enum = operators
           
           
          }
        });
        
        break;

      default:
        setVisible(false);
        break;
    }
  };

  const conditionCheckboxChangeHandler = (props, handler) => {
    console.log(props.target.value);
    handler(props);
    const isVisible = props.target.value;
    isVisible === "false" ? setVisible(true) : setVisible(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    submitValidationHandler(event);
    if (isValid && !hasError) {
      let data = {}; //data to send to backend

      data["ticketStatus"] = { id: 1, description: "Open", status: "Open" };
      for (const input in inputs) {
        if (input !== "asset") {
          if (input === "item" || input === "ticketImpact") {
            data[input] = {
              id: parseInt(inputs[input].value), // filling of json body dynamically
            };
          } else {
            data[input] = inputs[input].value;
          }
        }
      }

      switch (data.ticketImpact.id) {
        case 1:
          data["ticketImpact"].impactName = "Low";
          data["ticketImpact"].impactType = "";
          break;
        case 2:
          data["ticketImpact"].impactName = "Medium";
          data["ticketImpact"].impactType = "";
          break;
        case 3:
          data["ticketImpact"].impactName = "High";
          data["ticketImpact"].impactType = "";
          break;
        case 4:
          data["ticketImpact"].impactName = "Critical";
          data["ticketImpact"].impactType = "";
          break;
        default:
          break;
      }
      data["feeAmountProposal"]=inputs["fee"]["feeAmountProposal"].value
      var response;
      var message;
      console.log(data);

      //APIS CALLING
      if (!props.ticketData) {
        response = await CreateTicket(data);
        message = "Ticket created successfully!";
      } else {
        
        response = await CreateTicket(data);
        message = "Ticket updated successfully!";
      }

      console.log("submit:" + JSON.stringify(response));
      if (response.success) {
        // success alert
        alert.setSuccess((prev) => [...prev,{
          status: true,
          message: message,
          index:prev.length
        }]);
        if (isNaN(props.steps)) {
          return props.custom ? props.onSubmit(false, true) : navigate("..");
        }
        return props.handleNext({
          id: response.object.id,
          name: data.name,
        });
      } else {
        alert.setError((prev) => [...prev,{ status: true, messages: response.errors,index:prev.length }]);
        return props.custom ? props.onSubmit(false) : null;
      }
    }
    return props.custom ? props.onSubmit(false) : null;
  };

  return (
    <>
   
      <Form
        title={"Item"}
        inputs={inputs}
        errorMessages={errorMessages}
        isValid={isValid}
        custom={props.custom ?? false}
        hasError={hasError}
        activeStep={props.activeStep}
        steps={props.steps}
        onSubmit={handleSubmit}
        externalSubmit={props.externalSubmit ?? null}
        handleBack={props.handleBack ?? null}
      >
        {visible && feeInputs}
      </Form>
    </>
  );
}
